export function getNewDate() {
    return new Date();
}